(function (app, ng) {
    app.controller("covidFigMessagesCtrl", covidFigMessagesCtrl);
    covidFigMessagesCtrl.$inject = ["$mdDialog", "data"];

    function covidFigMessagesCtrl($mdDialog, data) {
        var $ctrl = this;

        $ctrl.closeDialog = function ($event) {
            return $mdDialog.hide($event);
        };

        $ctrl.$onInit = function () {
            $ctrl.data = data;
        };
    }
})(window.app, window.angular); // jshint ignore:line